export const baseUrl = '/api/recommendation';
